// Using the same value as defined by @creditornot/cb-form
export const BREAKPOINT_MOBILE = 550;
